module.exports = __webpack_public_path__ + "static/media/standardDefault.01daf1b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headers/standardDefault.png
// module id = 1240
// module chunks = 0